<script setup>
import { defineProps, defineEmits, computed, watch, ref } from 'vue';
import { debounce } from 'quasar';

const props = defineProps({
  step: { type: Number, default: 1 },
  value: { type: Number, default: 0 },
  min: { type: Number, default: 0 },
  max: { type: Number, default: Infinity },
  canAdd: { type: Boolean, default: null },
  canRe: { type: Boolean, default: null },
  debounceTime: { type: Number, default: 0 },
});
const emits = defineEmits(['input', 'change', 'overflow']);

const _canRe = computed(() => {
  if (props.canRe !== null) return props.canRe;
  return props.value > props.min;
});
const _canAdd = computed(() => {
  if (props.canAdd !== null) return props.canAdd;
  return props.value < props.max;
});

let stepCeche = 0;
function onReduce() {
  if (!_canRe.value) {
    emits('below')
    return
  }
  stepCeche -= 1;
  emits('input', props.value - props.step);
}
function onAdd() {
  if (!_canAdd.value) {
    emits('overflow')
    return
  }
  stepCeche += 1;
  emits('input', props.value + props.step);
}
const watchFunction = debounce((v, oldV) => {
  if (v !== oldV) emits('change', v, stepCeche);
  stepCeche = 0;
}, props.debounceTime);
watch(() => props.value, watchFunction);
</script>

<template>
  <div class="mcounter">
    <div :class="['mcounter-it', { dis: !_canRe }]" @click="onReduce">
      <i class="iconfont dm-Minus" />
    </div>
    <div class="mcounter-value">{{ props.value }}</div>
    <div :class="['mcounter-it', { dis: !_canAdd }]" @click="onAdd">
      <i class="iconfont dm-Add1" />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.mcounter {
  font-weight: bold;
  font-size: 20px;
  display: flex;
  align-items: center;
  &-it {
    color: #fff;
    position: relative;
    width: 26px;
    height: 26px;
    &.dis {
      //pointer-events: none;
      background: $disabledBg;
      color: $disabledFont;
    }
    i {
      color: #111827;
      font-size: 26px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: 400;
    }
    border-radius: 50%;
  }
  &-value {
    min-width: 35px;
    text-align: center;
  }
}
</style>
